<template>
  <div style="background:#f5f5f5;min-height:100vh">
    <!-- 顶部导航 -->
    <div class="van-nav-bar van-nav-bar--fixed" style="background:#fff">
      <div class="van-nav-bar__content">
        <div class="van-nav-bar__left" @click="$router.back()">
          <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
        </div>
        <div class="van-nav-bar__title van-ellipsis">礼金明细记录</div>
      </div>
    </div>

    <div style="padding-top:56px">
      <!-- 统计卡片 -->
      <div style="margin:12px 16px;background:linear-gradient(135deg,#cf866b,#e8a98a);border-radius:12px;padding:20px;color:#fff;display:flex;justify-content:space-around;text-align:center">
        <div>
          <div style="font-size:22px;font-weight:700">{{ totalBonus }}</div>
          <div style="font-size:12px;opacity:.85;margin-top:4px">累计礼金(元)</div>
        </div>
        <div style="width:1px;background:rgba(255,255,255,0.3)"></div>
        <div>
          <div style="font-size:22px;font-weight:700">{{ records.length }}</div>
          <div style="font-size:12px;opacity:.85;margin-top:4px">邀请人数</div>
        </div>
      </div>

      <!-- 记录列表 -->
      <div style="margin:0 16px">
        <div v-if="loading" style="text-align:center;padding:40px 0;color:#999;font-size:13px">加载中...</div>

        <div v-else-if="records.length === 0" style="text-align:center;padding:60px 0">
          <div style="font-size:40px">🎁</div>
          <div style="color:#ccc;font-size:13px;margin-top:12px">暂无礼金记录</div>
          <div style="color:#ccc;font-size:12px;margin-top:6px">邀请好友注册即可获得礼金</div>
        </div>

        <div v-else>
          <div v-for="(item, i) in records" :key="i"
            style="background:#fff;border-radius:10px;padding:14px 16px;margin-bottom:10px;display:flex;justify-content:space-between;align-items:center">
            <div style="display:flex;align-items:center;gap:12px">
              <div style="width:40px;height:40px;border-radius:50%;background:#fef0eb;display:flex;align-items:center;justify-content:center;font-size:18px">🎁</div>
              <div>
                <div style="font-size:14px;color:#333;font-weight:500">邀请礼金</div>
                <div style="font-size:11px;color:#999;margin-top:3px">被邀请人：{{ item.username }}</div>
                <div style="font-size:11px;color:#bbb;margin-top:2px">{{ item.date }}</div>
              </div>
            </div>
            <div style="color:#e8733a;font-weight:700;font-size:16px">+¥{{ item.bonus }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'inviteRecord',
  data() {
    return {
      loading: true,
      records: [],
    };
  },
  computed: {
    totalBonus() {
      return this.records.reduce((sum, r) => sum + parseFloat(r.bonus || 0), 0).toFixed(2);
    }
  },
  created() {
    this.$apiFun.post('/api/invite/records', {}).then(res => {
      if (res.code === 200) {
        this.records = res.data || [];
      }
    }).catch(() => {}).finally(() => {
      this.loading = false;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inviteRecord.vue